import React from "react";
import {sendMessageCreator, updateNewMessageBodyCreator} from "../../../Redux/dialogsReducer";
import Dialogs from "./Dialogs";
import {connect} from "react-redux";

let mapStateToProps = (state) => {
    return {
        dialogsPage: state.dialogsPage
    }
}
let mapDispatchToProps = (dispatch) => {
    return {
        sendMessage: (text) => {
            dispatch(sendMessageCreator(text));
        },
        updateNewMessageBody: (body) => {
            dispatch(updateNewMessageBodyCreator(body))
        }
    }
}

const DialogsContainer = connect(mapStateToProps, mapDispatchToProps)(Dialogs)

export default DialogsContainer;



















// import React from "react";
// import Dialogs from "./Dialogs";
// import {connect} from "react-redux";
// import {sendMessageCreator, setDialogsCreator, updateNewMessageCreator} from "../../../Redux/dialogsReducer";
//
//
// class DialogContainer extends React.Component{
//     constructor(props) {
//         super(props);
//     }
//     componentDidMount() {
//         if (this.props.dialogs.length === 0){
//             this.props.setDialogs([
//                 {id: 0, name: "Tommy Shelby", avatar: "https://i2-prod.liverpoolecho.co.uk/incoming/article23503282.ece/ALTERNATES/s1200c/1_Peaky-Blinders.jpg", time: '10:06', message: 'Oh! Relinquish is just a fancy word for lose!', returnMessages: [{message: 'HI, i have checked about your query, there is no any problem like that...'}, {message: 'Dear You May again download the package directly...'}]},
//                 {id: 1, name: 'Beth Harmon', avatar: "https://wallpapers.com/images/high/the-queen-s-gambit-beth-digital-fan-art-mdazcu7vb7ga4sss.jpg", time: '10:06', message: 'Oh! Relinquish is just a fancy word for lose!', returnMessages: [{message: "You can change what you do, but you can't change what you want!"}, {message: 'Do you really think the best reason to get married is because you’re sorry?'}]},
//                 {id: 2, name: 'Otis Milburn', avatar: "https://i.pinimg.com/564x/7e/89/c5/7e89c51d342ef0f5fee570eb87165b55.jpg", time: '10:06', message: 'Oh! Relinquish is just a fancy word for lose!', returnMessages: [{message: "We all mess up and do impure things. Doesn't mean we're bad people."}, {message: 'You don’t tell me what to do. I tell you what to do!'}]},
//                 {id: 3, name: "Monica Geller", avatar: "https://blogscdn.thehut.net/app/uploads/sites/35/2020/04/everyfriendsoutfit5_1585754531.jpg", time: '10:06', message: 'Oh! Relinquish is just a fancy word for lose!', returnMessages: [{message: "Hey, if we're both going crazy, we'll go crazy together, right?"}, {message: 'By the way, how did that feel, losing to a girl?'}]},
//                 {id: 4, name: "Emily Cooper", avatar: 'https://pyxis.nymag.com/v1/imgs/720/78a/c64f539aa5d5cefac27ccd5b1b64e85a91-emily-in-paris.rsquare.w700.jpg', time: '10:06', message: 'Oh! Relinquish is just a fancy word for lose!', returnMessages: [{message: "I feel like I'm dreaming and I'm about to wake up."}, {message: 'I know you all hate me, and I’m sorry, but I don’t care.'}]}
//
//             ])
//         }
//     }
//     render() {
//         return(
//             <Dialogs users={this.props.dialogs}
//                      messageChange={this.props.updateNewMessageBody}
//                      send={this.props.sendMessage}/>
//         )
//     }
//
// }
//
// let mapStateToProps = (state) => {
//     return {
//         dialogs: state.dialogsPage.dialogs
//     }
// }
//
// let mapDispatchToProps = (dispatch) => {
//     return {
//         sendMessage: (id) => {
//             dispatch(sendMessageCreator(id));
//         },
//         updateNewMessageBody: (body) => {
//             dispatch(updateNewMessageCreator(body))
//         },
//         setDialogs: (dialogs)=>{
//             dispatch(setDialogsCreator(dialogs))
//         }
//     }
// }
//
// const DialogsContainer = connect(mapStateToProps,mapDispatchToProps) (DialogContainer)
// export default DialogsContainer
//
//
